import React from "react";
import PropTypes from "prop-types";

const Context = React.createContext();

const HIGHLIGHT_TOOLTIP_LIMIT = 786;

function Component({ children, calculateTooltipPosition }) {
  const [state, setState] = React.useState({
    visible: false,
    clickedContent: undefined,
    contentId: "",
    mobileFunction: false,
  });
  const onPlainTextClick = (
    contentId,
    event,
    contentTitle,
    contentDescription,
    contentImage
  ) => {
    const viewportWidth = window.innerWidth;
    const {
      scrollX,
      scrollY,
      modalTop: top,
      modalLeft: left,
      highLightText,
      highLightTextHeight,
      arrowPosition,
    } = calculateTooltipPosition(event);
    setState({
      contentId,
      contentTitle,
      contentDescription,
      contentImage,
      visible: true,
      clickedContent: {
        scrollX,
        scrollY,
        left,
        top,
        highLightText,
        highLightTextHeight,
        arrowPosition,
      },
      mobileFunction: viewportWidth < HIGHLIGHT_TOOLTIP_LIMIT,
    });
  };

  const onCloseTooltip = () => {
    setState({
      visible: false,
      clickedContent: undefined,
      mobileFunction: false,
    });
  };
  return (
    <Context.Provider value={{ state, onCloseTooltip, onPlainTextClick }}>
      {children}
    </Context.Provider>
  );
}
Component.propTypes = {
  /**
   * Element to be displayed as child for Highlight Context Provider
   */
  children: PropTypes.element,
  /**
   * Function to calculate the tooltip Position on screen
   */
  calculateTooltipPosition: PropTypes.func,
};

export const HighlightProvider = { Context, Component };
